// Built-in defaults for the Agent node's configurable prompts.
//
// 🔴 TWIN FILE — this is a verbatim copy of `Model/AgentArchitect/AgentPromptDefaults.cs`.
//    It exists so the Flow editor can seed a new Agent node with the built-in text (see applyNodeDefaults)
//    and show it, as the placeholder of an empty field, on an older node that was saved before the key
//    existed. The RUNTIME never reads this file: the node resolves its prompts from the C# constants, and
//    a blank field means "use the built-in", so a value here that has drifted from C# misleads the
//    operator without changing a single turn.
//
//    `AgentPromptDefaultsParityTests` (BAL.Tests) compares this file against the C# constants character
//    for character and fails the build if they diverge. Edit the C# file, then re-run that test — its
//    failure message prints what to paste here.
//
//    🔴 The keys below are the CONSTANT names in camelCase, not the node.Data keys. The node.Data keys
//    carry the node's prefix, so the editor has to spell the pairing out when it seeds or shows one:
//        finalSummaryTemplate -> node.data.agentFinalSummaryTemplate
//
//    `PROMPT_DEFAULT_ROWS` below is the line count of each default, used as the textarea's `rows` so
//    the whole placeholder is visible: an EMPTY textarea cannot be scrolled, so a box shorter than
//    its placeholder silently hides the rest of the text.

export const AGENT_PROMPT_DEFAULTS = {
    // Final summary — the prompt sent after every tool/knowledge source has run; its reply is the answer
    finalSummaryTemplate: "## เป้าหมาย (Goal):\n{goal}\n\n## คำถาม/ข้อความจากผู้ใช้:\n{userMessage}\n\n## ข้อมูลที่รวบรวมได้ ({toolCount} รายการ):\n{toolResultsText}\n\n## รูปแบบการตอบ (สำคัญมาก):\nแบ่งคำตอบเป็น section ตามข้อมูลที่รวบรวมได้ โดยใช้ --- คั่นระหว่าง section\n\n**รูปแบบ:**\n[emoji] **[หัวข้อที่สรุปจากข้อมูลชุดที่ 1]**\n- เนื้อหาสรุป...\n\n---\n\n[emoji] **[หัวข้อที่สรุปจากข้อมูลชุดที่ 2]**\n- เนื้อหาสรุป...\n\n---\n\n[emoji] **[หัวข้อที่สรุปจากข้อมูลชุดที่ n]**\n- เนื้อหาสรุป...\n\n## กฎการตอบ:\n1. สร้างหัวข้อ section ตามเนื้อหาจริงที่ได้จากข้อมูล (อย่าใช้หัวข้อตายตัว)\n2. ใช้ emoji ที่เหมาะสมกับเนื้อหาแต่ละ section\n3. ใช้ --- คั่นระหว่าง section\n4. สรุปข้อมูลจากทุกแหล่งอย่างครบถ้วน\n5. ตอบเป็นกันเองและเข้าใจง่าย\n6. ห้ามบอกชื่อ Tool หรือ Knowledge Source ในคำตอบ\n\nกรุณาสรุปคำตอบ:",
}

/** Line count of each default — drives the textarea `rows` so the placeholder is never clipped. */
export const PROMPT_DEFAULT_ROWS = {
    finalSummaryTemplate: 35,
}
